/**
 * ImportResultStep — final status after all apply waves complete.
 * Shows per-wave results with created/error counts and snapshot labels.
 * FR-034
 */

import React from 'react';
import { Button } from '@/components/ui/button';
import type { WaveApplyResult } from '@roll1/shared';

interface ImportResultStepProps {
  waveResults: WaveApplyResult[];
  onClose: () => void;
}

export function ImportResultStep({ waveResults, onClose }: ImportResultStepProps) {
  const totalApplied = waveResults.reduce((sum, w) => sum + w.applied, 0);
  const totalFailed = waveResults.reduce((sum, w) => sum + w.failed, 0);
  const hasErrors = totalFailed > 0;

  return (
    <div className="space-y-4">
      {/* [STYLE_TODO] Success/partial success state with icon */}
      <p className="text-ui font-medium">
        {hasErrors ? 'Импорт завершён с ошибками' : 'Импорт завершён успешно'}
      </p>

      <div className="text-ui">
        Всего создано: <strong>{totalApplied}</strong>
        {totalFailed > 0 && (
          <span className="text-destructive ml-2">Ошибок: <strong>{totalFailed}</strong></span>
        )}
      </div>

      <div className="space-y-2">
        {waveResults.map((wave) => (
          <div key={wave.wave} className="p-3 border rounded">
            <p className="text-ui font-medium">{wave.label}</p>
            <div className="text-meta mt-1">
              <span className="text-ok">Создано: {wave.applied}</span>
              {wave.failed > 0 && (
                <span className="text-destructive ml-2">Ошибок: {wave.failed}</span>
              )}
            </div>
            {wave.errors.length > 0 && (
              <div className="mt-1 text-meta text-destructive space-y-0.5 max-h-20 overflow-auto">
                {wave.errors.map((err, i) => (
                  <p key={i}>{err}</p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <p className="text-meta text-muted-foreground">
        Для каждой волны создан snapshot. Используйте панель snapshot'ов для отката.
      </p>

      <div className="flex justify-end">
        <Button onClick={onClose}>Закрыть</Button>
      </div>
    </div>
  );
}
